import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import _get from "lodash/get";
import { MessageType } from '@bowtie-web/common/lib/notification';
import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
import CheckCircleOutline from '@material-ui/icons/CheckCircleOutline';
import Close from '@material-ui/icons/Close';
import InfoOutlined from '@material-ui/icons/InfoOutlined';
import clsx from 'clsx';
import * as React from 'react';
import { BOWTIE_PINK, GREEN_DAY, YELLOW_SUBMARINE, HOTEL_CALIFORNIA, WHITE } from '../palette';
import { Error } from '../svg/icons';
const iconMapping = {
  [MessageType.INFO]: InfoOutlined,
  [MessageType.ERROR]: Error,
  [MessageType.WARNING]: Error,
  [MessageType.SUCCESS]: CheckCircleOutline
};
const useStyles = makeStyles(theme => ({
  container: {
    position: 'relative'
  },
  root: {
    display: 'flex',
    padding: theme.spacing(2),
    flexGrow: 'initial',
    [theme.breakpoints.down('xs')]: {
      flexGrow: 1
    },
    flexWrap: 'nowrap',
    boxShadow: ({
      disableElevation
    }) => disableElevation ? 'none' : '-1px 2px 11px 0 rgba(167, 167, 167, 0.5)',
    borderTop: 'solid 4px',
    backgroundColor: WHITE
  },
  message: {
    display: 'grid',
    gridGap: 16,
    flexGrow: 1,
    flexWrap: 'nowrap',
    alignItems: 'center',
    wordBreak: 'break-word',
    overflow: 'auto',
    color: 'inherit',
    padding: theme.spacing(1, 0)
  },
  action: {
    marginRight: theme.spacing(-1),
    paddingLeft: theme.spacing(1)
  },
  closeIcon: {
    fontSize: 16
  },
  icon: {},
  primaryMessage: {},
  [MessageType.INFO]: {
    borderColor: 'transparent'
  },
  [MessageType.ERROR]: {
    borderColor: HOTEL_CALIFORNIA,
    '& $icon': {
      color: HOTEL_CALIFORNIA
    },
    '& $primaryMessage': {
      color: HOTEL_CALIFORNIA
    }
  },
  [MessageType.WARNING]: {
    borderColor: YELLOW_SUBMARINE,
    '& $icon': {
      color: YELLOW_SUBMARINE
    }
  },
  [MessageType.SUCCESS]: {
    borderColor: GREEN_DAY,
    '& $icon': {
      color: GREEN_DAY
    },
    '& $primaryMessage': {
      color: GREEN_DAY
    }
  },
  progress: {
    position: 'absolute',
    bottom: 0,
    height: 2,
    width: 0,
    backgroundColor: BOWTIE_PINK,
    animation: '$progress linear 1'
  },
  '@keyframes progress': {
    from: {
      width: '100%'
    },
    to: {
      width: '0%'
    }
  }
}));

const Toast = props => {
  const {
    children,
    onClose,
    variant = MessageType.INFO,
    timeout,
    disableElevation = false
  } = props;
  const Icon = React.useMemo(() => iconMapping[variant], [variant]);
  const classes = useStyles({
    variant,
    disableElevation
  });
  const childrenArr = React.Children.toArray(children);
  return _jsxs("div", {
    className: classes.container,
    children: [_jsxs("div", {
      className: clsx(classes.root, classes[variant]),
      children: [_jsxs("div", {
        className: classes.message,
        children: [_jsxs(Box, {
          display: "flex",
          flexWrap: "nowrap",
          children: [_jsx(Icon, {
            className: classes.icon
          }), _jsx(Box, {
            ml: 1.5,
            lineHeight: "24px",
            className: classes.primaryMessage,
            children: childrenArr[0]
          })]
        }), childrenArr.slice(1).map((child, index) => _jsxs(React.Fragment, {
          children: [_jsx(Divider, {}), child]
        }, _get(child, 'key', index)))]
      }), onClose && _jsx("div", {
        className: classes.action,
        children: _jsx(IconButton, {
          "aria-label": "close",
          onClick: onClose,
          children: _jsx(Close, {
            className: classes.closeIcon
          })
        })
      })]
    }), timeout && timeout > 0 ? _jsx("div", {
      className: classes.progress,
      style: {
        animationDuration: `${timeout}ms`
      }
    }) : null]
  });
};

export default Toast;